import { createAction } from '@reduxjs/toolkit';
import { ActiveTask, ErrorObject } from 'types';

export const fetchActiveTasks = createAction('TASKS/FETCH');
export const fetchActiveTasksRequest = createAction('TASKS/FETCH_REQUEST');
export const fetchActiveTasksSuccess = createAction<ActiveTask[]>('TASKS/FETCH_SUCCESS');
export const fetchActiveTasksFailure = createAction<ErrorObject>('TASKS/FETCH_FAILURE');
export const fetchActiveTasksFulfill = createAction('TASKS/FETCH_FULFILL');

export const deleteTaskByJob = createAction<{ jobId: string }>('TASKS/DELETE');
export const deleteTaskByJobRequest = createAction('TASKS/DELETE_REQUEST');
export const deleteTaskByJobSuccess = createAction('TASKS/DELETE_SUCCESS');
export const deleteTaskByJobFailure = createAction<ErrorObject>('TASKS/DELETE_FAILURE');

export const resetTaskByJob = createAction<{ jobId: string }>('TASKS/RESET_TASK');
export const resetTaskByJobRequest = createAction('TASKS/RESET_TASK_REQUEST');
export const resetTaskByJobSuccess = createAction('TASKS/RESET_TASK_SUCCESS');
export const resetTaskByJobFailure = createAction<ErrorObject>('TASKS/RESET_TASK_FAILURE');
